import {Component, OnInit} from '@angular/core';
import {PaysonPaymentService} from '../../../../services/payson-payment.service';
import {ShoppingCartService} from '../../../../services/shopping-cart.service';
import { NgxSpinnerService } from 'ngx-spinner';
import {Router} from '@angular/router';
import {PaymentType} from '../payment-selection/payment-selection.component';

@Component({
  selector: 'app-payson-payment',
  templateUrl: './payson-payment.component.html',
  styleUrls: ['./payson-payment.component.css']
})
export class PaysonPaymentComponent implements OnInit {

  snippet: string;
  showPaysonForm = false;

  constructor(
    public paysonRequestService: PaysonPaymentService ,
    public cart: ShoppingCartService,
    private spinner: NgxSpinnerService,
    private router: Router
    ) {
    this.cart.priceChangedInbasket.subscribe(
      (data: boolean) => {
        if (data) {
          // invalidating payson previously sent request -IMPORTANT!
          this.cart.paysonSnippet = '';
          this.cart.paymentType = '';
          this.showPaysonForm = false;
          this.ngOnInit();
        }
      });
  }

  ngOnInit() {
     console.log('initiating the payson response page');
    if (this.cart.paysonSnippet) {
      this.spinner.hide();
      this.snippet = this.cart.paysonSnippet;
      this.showPaysonForm = true;
    } else
      if (    this.cart.paymentType  && this.cart.paymentType === 'PAYSON') {
        this.spinner.show();
        this.paysonRequestService.sendPaysonPaymentRequest(this.cart.basket).subscribe(
        (response) => {
          this.spinner.hide();
          // console.log(response);
          // console.log(response.statusText);
          // console.log(response.body);
          const body = response.body;
          // console.log(body['snippet']);
          this.snippet = body['snippet'];
          this.showPaysonForm = true;
          this.cart.paysonSnippet = this.snippet;
          this.cart.saveBasket();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
          // noinspection JSIgnoredPromiseFromCall
          this.router.navigate(['/error']);
        }
      );
    }
    // console.log(this.snippet);
    }
}
